import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@material-ui/core/styles';
import LocalVideoPreview from '../LocalVideoPreview/LocalVideoPreview';
import ToggleAudioButton from '../Controls/ToggleAudioButton/ToggleAudioButton';
import ToggleVideoButton from '../Controls/ToggleVideoButton/ToggleVideoButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import EntryDialog from '../EntryModal/EntryModal';
import { MeetingContext } from '../../App';
import useLocalVideoToggle from '../../hooks/useLocalVideoToggle/useLocalVideoToggle';

const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  height: '100%',
  display: 'grid',
  gridTemplateColumns: `65% 35%`,
  gridTemplateRows: '100%',
  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: `auto`,
    gridTemplateRows: `65% 35%`,
    direction: 'revert',
  },
}));

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    previewArea: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    detailsArea: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    localVideo: {
      display: 'flex',
      borderRadius: '15px',
      justifyContent: 'center',
      position: 'relative',
      zIndex: 101,
      alignItems: 'center',
    },
    mediaControl: {
      bottom: '16px',
      display: 'flex',
      left: '50%',
      marginLeft: '-80px',
      position: 'absolute',
    },
    videoMutedText: {
      color: 'white',
      fontSize: '2rem',
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        justifyContent: 'center',
        padding: '10px',
        width: '100%',
        height: '100%',
        backgroundColor: 'black',
      },
    },
  })
);

export function AudioVideoControl({ roomState }) {
  const isReconnecting = roomState === 'reconnecting';
  let classes = useStyles();

  return (
    <div className={classes.mediaControl}>
      <ToggleAudioButton disabled={isReconnecting} />
      <ToggleVideoButton disabled={isReconnecting} />
    </div>
  );
}

export default function LandingPage() {
  const roomState = useRoomState();
  let classes = useStyles();
  const { isMobile } = useContext(MeetingContext);
  const [isVideoEnabled] = useLocalVideoToggle();
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    if (!isMobile) {
      let diff;
      let videoContainerDimension = document.getElementById('previewArea').getBoundingClientRect();
      let videoDivWidth = videoContainerDimension.width * 0.8;
      let videoDivHeight = videoContainerDimension.height * 0.65;
      diff =
        ((window.screen.width * window.devicePixelRatio) / window.screen.height) *
        window.devicePixelRatio *
        (videoDivHeight / videoDivWidth);
      if (diff < 1) {
        setHeight(videoDivHeight);
        setWidth(videoDivWidth * diff);
      } else {
        setHeight(videoDivHeight / diff);
        setWidth(videoDivWidth * 0.8);
      }
    }
  });

  return isMobile ? (
    <>
      {isVideoEnabled ? <LocalVideoPreview /> : <div className={classes.videoMutedText}>Video is Muted</div>}
      <EntryDialog></EntryDialog>
    </>
  ) : (
    <Container>
      <div id="previewArea" className={classes.previewArea}>
        {
          <div
            className={classes.localVideo}
            style={{
              backgroundColor: 'black',
              width: width,
              height: height,
            }}
          >
            {isVideoEnabled ? (
              <LocalVideoPreview></LocalVideoPreview>
            ) : (
              <span className={classes.videoMutedText}>Video is Muted</span>
            )}
            <AudioVideoControl roomState={roomState} />
          </div>
        }
      </div>
      <div className={classes.detailsArea}>
        <EntryDialog></EntryDialog>
      </div>
    </Container>
  );
}
